"use client";
import { Tabs } from "@mantine/core";
import Image from "next/image";
import { useState } from "react";
import TabList from "./TabList";
import TabPanel from "./TabPanel";

export default function MasterclassTabs() {
    const [activeTab, setActiveTab] = useState<string | null>("Alle");
    const tabs = [
        {
            value: "Kostenlos",
            text: "Kostenlos",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        activeTab === "Kostenlos"
                            ? "/Icons/TabIcons/likeCyan.svg"
                            : "/Icons/TabIcons/likeGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Neu",
            text: "Neu",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        activeTab === "Neu"
                            ? "/Icons/TabIcons/plusCyan.svg"
                            : "/Icons/TabIcons/plusGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Coming-soon",
            text: "Coming soon",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        activeTab === "Coming-soon"
                            ? "/Icons/TabIcons/clockCyan.svg"
                            : "/Icons/TabIcons/clockGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Alle",
            text: "Alle",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        activeTab === "Alle"
                            ? "/Icons/TabIcons/tvCyan.svg"
                            : "/Icons/TabIcons/tvGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },

        {
            value: "Kostenpflichtig",
            text: "Kostenpflichtig",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        activeTab === "Kostenpflichtig"
                            ? "/Icons/TabIcons/paidCyan.svg"
                            : "/Icons/TabIcons/paidGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Meine-Masterclass",
            text: "Meine Masterclass",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        activeTab === "Meine-Masterclass"
                            ? "/Icons/TabIcons/userCyan.svg"
                            : "/Icons/TabIcons/userGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Favoriten",
            text: "Favoriten",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        activeTab === "Favoriten"
                            ? "/Icons/TabIcons/starCyan.svg"
                            : "/Icons/TabIcons/starGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
    ];
    return (
        <>
            <div className="pl-2  mx-auto">
                <Tabs
                    color="cyan"
                    variant="default"
                    value={activeTab}
                    onChange={setActiveTab}
                >
                    <div className="  ">
                        <div className="flex justify-center text-center">
                            <TabList tabs={tabs} activeTab={activeTab} />
                        </div>
                    </div>
                    <div className="my-10">
                        {tabs.map((tab) => (
                            <TabPanel value={tab.value} key={tab.value} />
                        ))}
                    </div>
                </Tabs>
            </div>
        </>
    );
}
